import React, {useState} from 'react';
import i18next from 'i18next';
import {useTranslation} from 'react-i18next';
import {styles} from './styles';
function Index() {
    const {t, i18n} = useTranslation();
    const [open, setOpen] = useState(false);
    const lang = i18n.language;

    const langLabel = lang === 'en' ? 'ENG' : 'ESP';
    const flagSrc = lang === 'en'
        ? require('../../assets/icons/english.png')
        : require('../../assets/icons/spanish.png');

    return (
        <div style={styles.content}>
            {open &&
                <div className='changeLangDropDown' style={styles.dropdown}>
                    <div
                        onClick={() => { i18next.changeLanguage('es'); setOpen(false); }}
                        style={styles.dropdownItem}
                    >
                        <img style={styles.iconsSmall} src={require('../../assets/icons/spanish.png')} />
                        <p style={styles.text}>{t('spanish')}</p>
                    </div>
                    <div
                        onClick={() => { i18next.changeLanguage('en'); setOpen(false); }}
                        style={{ ...styles.dropdownItem, borderBottom: 'none' }}
                    >
                        <img style={styles.iconsSmall} src={require('../../assets/icons/english.png')} />
                        <p style={styles.text}>{t('english')}</p>
                    </div>
                </div>
            }

            <div onClick={() => setOpen(!open)} style={styles.trigger}>
                <span style={styles.triggerLabel}>{langLabel}</span>
                <img style={styles.flagCircle} src={flagSrc} />
            </div>
        </div>
    );
}

export default Index;

